import { Sprout, Languages, MapPin, UserCheck } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const icons = [Sprout, Languages, MapPin, UserCheck];

export const WhyUs = ({ t }) => (
  <section id="why" data-testid="why-us-section" className="relative py-24 lg:py-32 bg-white overflow-hidden">
    <div className="absolute top-0 left-1/3 w-[480px] h-[480px] rounded-full bg-[#C5A059]/15 blur-[130px]" />
    <div className="relative max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal className="max-w-3xl">
        <SectionLabel testid="why-label">{t.why.label}</SectionLabel>
        <h2 data-testid="why-title" className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.05] mb-16">
          {t.why.title}
        </h2>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="why-pillars">
        {t.why.pillars.map((p, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={i} delay={i * 0.08} className="h-full">
              <div
                data-testid={`why-pillar-${i}`}
                className="group h-full p-8 lg:p-10 bg-[#F8F9FA] border border-[#0B132B]/10 hover:border-[#C5A059]/70 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
              >
                <Icon size={28} strokeWidth={1.5} className="text-[#C5A059] mb-8 group-hover:text-[#8C713A] transition-colors" />
                <h3 className="font-display text-2xl font-medium text-[#0B132B] mb-3">{p.title}</h3>
                <p className="text-sm text-slate-500 font-light leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
